import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Ico, Icons } from '../common';

export default function AdminNav() {
  const location = useLocation();
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const links = [
    { path: '/admin', label: 'Dashboard', icon: Icons.clipboard },
    { path: '/admin/players', label: 'Players', icon: Icons.users },
    { path: '/admin/tournaments', label: 'Tournaments', icon: Icons.trophy },
    { path: '/admin/matches', label: 'Matches', icon: Icons.calendar },
  ];

  return (
    <div style={s.nav}>
      {links.map(link => (
        <Link 
          key={link.path} 
          to={link.path} 
          style={{
            ...s.navLink,
            ...(location.pathname === link.path ? s.navLinkActive : {}),
            ...(isMobile ? s.navLinkMobile : {})
          }}
        >
          <Ico d={link.icon} size={isMobile ? 16 : 18} color={location.pathname === link.path ? (isMobile ? '#fff' : '#BDFF00') : '#5F6B80'} />
          {isMobile && <span style={{ fontSize: 9, marginTop: 2, fontWeight: 600 }}>{link.label}</span>}
          {!isMobile && <span style={{ marginLeft: 6 }}>{link.label}</span>}
        </Link>
      ))}
    </div>
  );
}

const s = {
  nav: { display: 'flex', gap: 8, marginBottom: 24, overflowX: 'auto', paddingBottom: 4 },
  navLink: { 
    padding: '8px 16px', 
    background: '#fff', 
    border: '1px solid #EEF1F6', 
    borderRadius: 8, 
    fontSize: 13, 
    fontWeight: 600, 
    color: '#5F6B80', 
    textDecoration: 'none', 
    whiteSpace: 'nowrap', 
    transition: 'all 0.2s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  navLinkMobile: {
    padding: '6px 8px',
    minWidth: 'auto',
    flex: 1,
    flexDirection: 'column',
    gap: 2
  },
  navLinkActive: {
    background: '#00205B',
    color: '#BDFF00',
    borderColor: '#00205B'
  }
};
